<div class="main-content">
  <div class="row">
    <p>{{ message | async }}</p>
  </div>
</div>
